import React, { useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import merge from 'lodash/merge'
import PropTypes from 'prop-types'

import * as navbarActions from 'domain/Navbar/actions'
import * as vesselActions from 'domain/Vessel/actions'
import paths from 'constants/paths'
import { selectors } from 'domain'
import withLayout from 'components/layout'

import Admin from './Admin'

const AdminContainer = ({
  vessels,
  vesselDetails,
  requestingVessels,
  requestingVesselDetails,
  savingVesselDetails,
  saveVesselDetailsError,
  pagination,
  searchQuery,
  requestVessel,
  requestVessels,
  saveVesselDetails,
  setSaveVesselDetailsError,
  setVesselPage,
  setVesselPageSize,
  setVesselSearchQuery,
  setSelectedNavbarItem,
  exportVessel,
}) => {
  useEffect(() => {
    setSelectedNavbarItem(paths.admin)
  }, [setSelectedNavbarItem])

  useEffect(() => {
    // Load all vessels once on mount — pagination/search are handled locally from cache
    requestVessels(1, pagination.pageSize, '')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Handler for unified save vessel details
  const handleSaveVesselDetails = ({ payload, onSuccess, onError, type }) =>
    saveVesselDetails({
      onError,
      onSuccess,
      payload: {
        createdAt: new Date().toISOString(),
        ...payload,
      },
      type,
    })

  return (
    <Admin
      exportVessel={exportVessel}
      onSaveVesselDetails={handleSaveVesselDetails}
      pagination={pagination}
      requestVessel={requestVessel}
      requestVessels={requestVessels}
      requestingVesselDetails={requestingVesselDetails}
      requestingVessels={requestingVessels}
      saveVesselDetailsError={saveVesselDetailsError}
      savingVesselDetails={savingVesselDetails}
      searchQuery={searchQuery}
      setSaveVesselDetailsError={setSaveVesselDetailsError}
      setVesselPage={setVesselPage}
      setVesselPageSize={setVesselPageSize}
      setVesselSearchQuery={setVesselSearchQuery}
      vesselDetails={vesselDetails}
      vessels={vessels}
    />
  )
}

AdminContainer.propTypes = {
  exportVessel: PropTypes.func.isRequired,
  pagination: PropTypes.shape({
    page: PropTypes.number,
    pageSize: PropTypes.number,
    total: PropTypes.number,
  }).isRequired,
  requestVessel: PropTypes.func.isRequired,
  requestVessels: PropTypes.func.isRequired,
  requestingVesselDetails: PropTypes.bool.isRequired,
  requestingVessels: PropTypes.bool.isRequired,
  saveVesselDetails: PropTypes.func.isRequired,
  saveVesselDetailsError: PropTypes.string,
  savingVesselDetails: PropTypes.bool.isRequired,
  searchQuery: PropTypes.string.isRequired,
  setSaveVesselDetailsError: PropTypes.func,
  setSelectedNavbarItem: PropTypes.func.isRequired,
  setVesselPage: PropTypes.func.isRequired,
  setVesselPageSize: PropTypes.func.isRequired,
  setVesselSearchQuery: PropTypes.func.isRequired,
  vesselDetails: PropTypes.object,
  vessels: PropTypes.array.isRequired,
}

const mapStateToProps = state => ({
  pagination: selectors.vesselPaginationSelector(state),
  requestingVesselDetails: selectors.requestingVesselSelector(state),
  requestingVessels: selectors.requestingVesselsSelector(state),
  saveVesselDetailsError: selectors.saveVesselDetailsErrorSelector(state),
  savingVesselDetails: selectors.savingVesselDetailsSelector(state),
  searchQuery: selectors.vesselSearchQuerySelector(state),
  vesselDetails: selectors.vesselSelector(state),
  vessels: selectors.vesselsSelector(state),
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(merge({}, navbarActions, vesselActions), dispatch)

export default withLayout(
  connect(mapStateToProps, mapDispatchToProps)(AdminContainer)
)
